import { Fragment } from "react";
import { Link, useLocation } from "@tanstack/react-router";
import { Text } from "~/components/Text";
import { Inline } from "~/components/Inline";

interface PaginationProps {
  page: number;
  totalPages: number;
  prevPage?: number;
  nextPage?: number;
}

const getPagePath = (page: number, pathname: string): string => {
  let path = pathname;
  path = path.replace(/\/page\/\d+$/, '') || '/';
  if (page === 1) return path;

  return `${path}/page/${page}`;
};

export const Pagination = ({
  page,
  totalPages,
  nextPage,
  prevPage,
}: PaginationProps) => {
  const { pathname } = useLocation();
  if (!(totalPages > 1)) return null;

  return (
    <Text as="div">
      <Inline separator="•">
        {[
          <Fragment key="page">
            Page <strong>{page}</strong> of <strong>{totalPages}</strong>
          </Fragment>,
          prevPage && (
            <Link
              key="prev"
              to={getPagePath(prevPage, pathname)}
              title={`Go to Page ${page - 1}`}
            >
              Page {page - 1}
            </Link>
          ),
          nextPage && (
            <Link
              key="next"
              to={getPagePath(nextPage, pathname)}
              title={`Go to Page ${page + 1}`}
            >
              Page {page + 1}
            </Link>
          ),
        ]}
      </Inline>
    </Text>
  );
};
